import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Switch } from 'react-router-dom';
import { MDBContainer, MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBIcon } from 'mdbreact';
import { withRouter, NavLink } from 'react-router-dom'
import { createBrowserHistory } from 'history';
import { Menu } from 'semantic-ui-react';
//import Navbar from './components/Navbar'
import StartGuide from './components/StartGuide'
import WhatIs from './components/WhatIs'
import CoverPage from './components/CoverPage'
import TimeLine from './components/TimeLine'
import Power28 from './components/Power28'
import PowerWeek from './components/PowerWeek'
import MakeUp from './components/MakeUp'
import LeaderBoard from './components/LeaderBoard'
import Badges from './components/Badges'
import Example from './components/Example'
import OneMoreStep from './components/OneMoreStep'
import Register2 from './modules/Register2'
import NavBarDaily24 from './NavBarDaily24'

import Amplify from 'aws-amplify';
import { Greetings } from 'aws-amplify-react';
import aws_exports from './aws-exports';

import { sample } from 'lodash';
import Home from './modules/Home';
import Login from './modules/Login';
import Start from './modules/Start';
import Register from './modules/Register';

Amplify.Logger.LOG_LEVEL = 'DEBUG';
Amplify.configure(aws_exports);

//const GreetingsTheme = {
//    navBar: {
//    },
 //   navRight: {
 //   },
 //   navButton: {
 //       border: '0',
 //       background: 'white',
 //       color: 'blue',
 //       borderBottom: '1px solid',
 //       fontSize: '0.8em'
 //   //}
//}
               //<MDBNavLink to="/start">Start</MDBNavLink>

const bgPink = {backgroundColor: '#262626'}
const Navbar2 = () => (
       <div>
          <MDBNavbar color="default-color" dark expand="md" >
            <MDBNavbarBrand to="/CoverPage"><img src="https://i.ibb.co/55mdkhH/slice1-3x.png" class="img-fluid" alt="Daily24" style={{ width:80 }} resizeMode="contain"></img> </MDBNavbarBrand>
            <MDBNavbarNav left>
               <MDBNavLink to="/CoverPage" activeClassName="active">CoverPage</MDBNavLink>
               <MDBNavLink to="/WhatIs" activeClassName="active">WhatIs</MDBNavLink>
               <MDBNavLink to="/timeLine" activeClassName="active">TimeLine</MDBNavLink>
               <MDBNavLink to="power28" activeClassName="active">Power28</MDBNavLink>
               <MDBNavLink to="powerWeek" activeClassName="active">PowerWeek</MDBNavLink>
               <MDBNavLink to="example" activeClassName="active">Example</MDBNavLink>
               <MDBNavLink to="makeUp" activeClassName="active">MakeUp</MDBNavLink>
               <MDBNavLink to="leaderBoard" activeClassName="active">LeaderBoard</MDBNavLink>
               <MDBNavLink to="badges" activeClassName="active">Badges</MDBNavLink>
            </MDBNavbarNav>
          </MDBNavbar>
    </div>
);


const Navbar3 = () => (
    <nav class="navbar navbar-expand-lg navbar-light bg-custom">
  <a class="navbar-brand" to="/CoverPage"><img class="nav_logo_img" src="https://i.ibb.co/55mdkhH/slice1-3x.png" alt="slice1-3x" border="0"/></a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarNav">
    <ul class="navbar-nav">
      <li class="nav-item">
        <MDBNavLink class="nav-link" exact to="/CoverPage" activeClassName="active">Start</MDBNavLink>
      </li>
      <li class="nav-item">
        <MDBNavLink class="nav-link" exact to="/WhatIs" activeClassName="active">WhatIs</MDBNavLink>
      </li>
      <li class="nav-item">
        <MDBNavLink class="nav-link" exact to="/timeline" activeClassName="active">TimeLine</MDBNavLink>
      </li>
      <li class="nav-item">
        <MDBNavLink class="nav-link" exact to="/Power28" activeClassName="active">Power28</MDBNavLink>
      </li>
      <li class="nav-item">
        <MDBNavLink class="nav-link" exact to="/powerWeek" activeClassName="active">PowerWeeks</MDBNavLink>
      </li>
      <li class="nav-item">
        <MDBNavLink class="nav-link" exact to="/example" activeClassName="active">Example</MDBNavLink>
      </li>
      <li class="nav-item">
        <MDBNavLink class="nav-link" exact to="/leaderboard" activeClassName="active">Leaderboard</MDBNavLink>
      </li>
      <li class="nav-item">
        <MDBNavLink class="nav-link" exact to="/badges" activeClassName="active">Badges</MDBNavLink>
      </li>
      <li class="nav-item">
        <MDBNavLink class="nav-link" exact to="/makeUp" activeClassName="active">MakeUp</MDBNavLink>
      </li>
      <li class="nav-item">
        <MDBNavLink class="nav-link" exact to="/oneMoreStep" activeClassName="active">OneMoreStep</MDBNavLink>
      </li>
      <li class="nav-item">
        <MDBNavLink class="nav-link" exact to="/register2" activeClassName="active">Register</MDBNavLink>
      </li>
    </ul>
  </div>
</nav>
     );

class App extends Component {
    constructor(props) {
        super(props);

        this.handleStateChange = this.handleStateChange.bind(this);
        this.onClick = this.onClick.bind(this);
        this.state = {
             collapse: false,
             active_menu: 'home',
             leaderboardName: 'atAppStart',
             participantId: 'fromAppBeginning'
        }
    }
    state = {
       collapseID: ''
    }

    toggleCollapse = collapseID => () => {
       this.setState(prevState => ({ collapseID: (prevState.collapseID !== collapseID ? collapseID : '') }));
    }

    onClick() {
        this.setState({
            collapse: !this.state.collapse,
        });
    }

    handleStateChange(authState, authData, participant_ID) {
        this.setState({
            authState: authState,
            authData: authData,
            participant_ID: participant_ID
        });
    }

//render={() => <SignupPage {...this.props} />}
            //<Route exact path="/start" render={() => (<Start data={this.state} />)} />
            //<Route exact path="/register" render={() => (<Register data={this.state} />)} />
            //<Route exact path="/register" component={Register} />
  render() {
    const { authState, authData, participant_ID } = this.state;
    const container = {height: 1300}
    return (
       <div>
          <Router>
       <div>
            <NavBarDaily24 />
            <Switch>
            <Route exact path="/" render={(props) => (<Register location={props.location} data={this.state} />)} />
            <Route path='/CoverPage' component={CoverPage} />
            <Route path='/WhatIs' component={WhatIs} />
            <Route path='/timeLine' component={TimeLine} />
            <Route path='/power28' component={Power28} />
            <Route path='/powerWeek' component={PowerWeek} />
            <Route path='/example' component={Example} />
            <Route path='/makeUp' component={MakeUp} />
            <Route path='/leaderBoard' component={LeaderBoard} />
            <Route path='/badges' component={Badges} />
            <Route path='/oneMoreStep' component={OneMoreStep} />
            <Route path='/register2' component={Register2} />
            <Route path='/start' component={Start} />
            </Switch>
          </div>
          </Router>
      </div>
            //<Link to={{
             //   pathname: '/start',
              //      search: '?leaderboardName',
               //     state: { participantId: 'initial' }
           // }}/>

            //<Router>
           // <div>
            //        <Route exact path="/" name="register" render={(props) => (
             //           <Register {...props} authState={authState} authData={authData}  />
              //      )}/>
               //     <Route exact path="/register" name="register" component={Register}/>
                //    <Route exact path="/start" name="start" component={Start}/>
           // </div>
            //</Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js